import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { ControlContainer, FormGroupDirective, NgControl } from '@angular/forms';
import { ValidationMessageService } from '@common/services/validation-message.service';
import { AbstractFormControlComponent } from './abstract-form-control.component';

@Component({
    selector: 'form-radio',
    styleUrls: ['form-controls.component.scss'],
    template: `
        <div>
            <span class="mr-2">{{ labelText | translate }}</span>
            <input class="k-radio" type="radio" kendoRadioButton [value]="radioValue" [formControlName]="controlName" />
        </div>
    `,
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RadioComponent extends AbstractFormControlComponent {
    @Input()
    controlName: string;
    @Input()
    contextual: string = null;
    @Input()
    labelText: string;
    @Input()
    radioValue: string;

    constructor(@Self() @Optional() controlDir: NgControl, validationMessageService: ValidationMessageService) {
        super(controlDir, validationMessageService);
    }
}
